import type { PriorityType } from '@features/invoices/api/types/invoice-alert.types';

export function formatInvoiceAmount(amount: number): string {
  if (amount < 1000) {
    return `${Math.round(amount)}`;
  }
  if (amount < 1_000_000) {
    return `${Math.round(amount / 1000)}K`;
  }
  if (amount < 1_000_000_000) {
    return `${Math.round(amount / 1_000_000)}M`;
  }
  return `${Math.round(amount / 1_000_000_000)}B`;
}

export function getPriorityOrder(priority: PriorityType): number {
  return priority === 'PastDue' ? 0 : 1;
}

export function sortAlerts<
  T extends { priorityType: PriorityType; totalAmount: number },
>(alerts: T[]): T[] {
  return [...alerts].sort((a, b) => {
    const priorityDiff =
      getPriorityOrder(a.priorityType) - getPriorityOrder(b.priorityType);
    if (priorityDiff !== 0) return priorityDiff;
    return b.totalAmount - a.totalAmount;
  });
}
